module.exports = __webpack_public_path__ + "custom-config/img/header_info_trade_college.e065d41.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/commons/header/info/header_info_trade_college.jpg
// module id = 4eWj
// module chunks = 2 3 4 6 7 8 9